// extracted by mini-css-extract-plugin
export default {"numberInput":"CustomFormNumber_numberInput__H-9ZC"};